import {equals} from 'ramda'
import css from '@/style/colors.less?inline'
import styles from './style.module.styl'
import {doc} from './doc'

const hexToRGB = hex => {
  let r = 0, g = 0, b = 0

  if (hex.length == 4) {
    r = "0x" + hex[1] + hex[1]
    g = "0x" + hex[2] + hex[2]
    b = "0x" + hex[3] + hex[3]
  } else if (hex.length == 7){
    r = "0x" + hex[1] + hex[2]
    g = "0x" + hex[3] + hex[4]
    b = "0x" + hex[5] + hex[6]
  }

  return [+r, +g, +b]
}

const colors = css.split('\n').map(x => x.trim()).filter(x => x.startsWith('--c-'))
  .map((x) => {
    const [name, color] = x.split(': ')
    return [name, color.slice(0, -1), hexToRGB(color.slice(0, -1))]
  })

export const Colors = doc(() =>
  <div>
    {colors.map(c => 
      <div
        className={styles.color}
        title={c.join(': ')}
        style={{[`--color`]: `var(${c[0]})`}}
      >
        <div className={styles.detail}>
          <div>{c[0].slice(4)}</div>
          <div>{c[1]}</div>
          <div>rgb({c[2].join(', ')})</div>
        </div>
      </div>
    )}
  </div>
)

